import { render } from "./Breadcrumb.vue?vue&type=template&id=5b7387e7"
import script from "./Breadcrumb.vue?vue&type=script&lang=ts"
export * from "./Breadcrumb.vue?vue&type=script&lang=ts"

import "./Breadcrumb.vue?vue&type=style&index=0&id=5b7387e7&lang=scss"
script.render = render

export default script